"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TabList", {
  enumerable: true,
  get: function get() {
    return _TabList["default"];
  }
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _Tab["default"];
  }
});

var _TabList = _interopRequireDefault(require("./js/TabList"));

var _Tab = _interopRequireDefault(require("./js/Tab"));